<ng-select
  #select
  #t="ngbTooltip"
  [ngbTooltip]="tooltip"
  [class]="class"
  [style]="style"
  [clearable]="multiple || clearable"
  [searchable]="false"
  [disabled]="disabled"
  [(ngModel)]="value"
  (change)="onChanged($event); onBlurRequest(select)"
  (click)="onBlurRequest(select); t?.close()"
  [placeholder]="placeholder"
  [ngClass]="classList"
  (open)="onOpen($event)"
  [appendTo]="appendTo"
  [multiple]="multiple"
  [closeOnSelect]="!multiple"
  placement="auto"
  container="body"
  [items]="items"
  bindLabel="label"
  bindValue="data">
  <ng-template ng-option-tmp let-item="item" let-item$="item$">
    <div *ngIf="item.badgeLabel; else labelOnly" class="d-flex align-items-center">
      <input type="checkbox" *ngIf="multiple" [ngModel]="item$.selected" class="me-2" />
      <div
        class="truncate-text"
        [style]="optionStyle"
        [ngbTooltip]="item.label"
        showTooltipIfTruncated
        container="body">
        {{ item.label }}
      </div>
      <span
        class="badge rounded-pill bg-warning-subtle text-warning-emphasis border border-warning-subtle ms-2 flex-shrink-0"
        [matTooltip]="item.badgeTooltip">
        <i class="fas fa-info-circle me-1"></i>{{ item.badgeLabel }}
      </span>
    </div>
    <ng-template #labelOnly>
      <div class="d-flex align-items-center">
        <input type="checkbox" *ngIf="multiple" [ngModel]="item$.selected" class="me-2" />
        <div
          class="truncate-text"
          [style]="optionStyle"
          [ngbTooltip]="item.label"
          showTooltipIfTruncated
          container="body">
          {{ item.label }}
        </div>
      </div>
    </ng-template>
  </ng-template>
  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    <div class="ng-value" *ngIf="items.length === 1">
      <span class="ng-value-label">{{ getItemLabel(items[0].data) }}</span>
    </div>
    <div class="ng-value" *ngIf="items.length > 1">
      <span class="ng-value-label">
        {{ 'CA::XItemsSelected' | abpLocalization: items.length }}...
      </span>
    </div>
  </ng-template>
</ng-select>
